import React, { useState, useEffect } from "react";
import { Edit, MapPin, Trash2, PlusCircle } from "react-feather";
import axios from "axios";
import { baseurl } from "../Baseurl";
import Swal from "sweetalert2";
import VisitorNavbar from "../component/VisitorNavbar";
import VisitorSidebar from "../component/VisitorSidebar";

const ShippingAddress = () => {
  const [shippingAddresses, setShippingAddresses] = useState([]);
  const [newAddress, setNewAddress] = useState({
    address_line1: "",
    address_line2: "",
    city: "",
    state: "",
    zip_code: "",
    country: "",
  });

  const [loading, setLoading] = useState(true);
  const cust_id = localStorage.getItem("cust_id");

  useEffect(() => {
    if (cust_id) {
      fetchShippingAddresses();
    }
  }, [cust_id]);

  const fetchShippingAddresses = async () => {
    try {
      const response = await axios.get(`${baseurl}get_shipping_addresses/${cust_id}`);
      if (response.data.success) {
        setShippingAddresses(response.data.addresses);
      }
    } catch (error) {
      console.error("Error fetching shipping addresses:", error);
    }
    setLoading(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewAddress((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAddAddress = async (e) => {
    e.preventDefault();

    if (!newAddress.address_line1 || !newAddress.city || !newAddress.zip_code) {
      Swal.fire({
        icon: "warning",
        title: "Incomplete details",
        text: "Please fill in all required fields.",
      });
      return;
    }

    try {
      const response = await axios.post(`${baseurl}add_shipping_address`, {
        ...newAddress,
        cust_id: cust_id,
      });

      if (response.data.success) {
        Swal.fire({
          icon: "success",
          title: "Address Added",
          text: "Your shipping address has been saved!",
        });
        fetchShippingAddresses();
        setNewAddress({
          address_line1: "",
          address_line2: "",
          city: "",
          state: "",
          zip_code: "",
          country: "",
        });
      }
    } catch (error) {
      console.error("Error adding shipping address:", error);
      Swal.fire({
        icon: "error",
        title: "Failed to add address",
        text: "Please try again later.",
      });
    }
  };

  const handleDeleteAddress = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to recover this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axios.delete(`${baseurl}delete_shipping_address/${id}`);
          Swal.fire("Deleted!", "Your address has been removed.", "success");
          fetchShippingAddresses();
        } catch (error) {
          Swal.fire("Error!", "Could not delete address.", "error");
        }
      }
    });
  };

  if (loading) {
    return <div className="text-center my-5">Loading...</div>;
  }

  return (
    <>
      <VisitorNavbar />
      <div className="container my-5">
        <div className="row g-4">
          <div className="col-md-3">
            <VisitorSidebar />
          </div>
          <div className="col-md-9">
            <div className="card shadow p-4">
              <h4 className="mb-3">Add Shipping Address</h4>
              <form onSubmit={handleAddAddress}>
                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label">Address Line 1 *</label>
                    <input
                      type="text"
                      name="address_line1"
                      className="form-control"
                      placeholder="Enter address line 1"
                      value={newAddress.address_line1}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Address Line 2</label>
                    <input
                      type="text"
                      name="address_line2"
                      className="form-control"
                      placeholder="Enter address line 2"
                      value={newAddress.address_line2}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">City *</label>
                    <input
                      type="text"
                      name="city"
                      className="form-control"
                      placeholder="Enter city"
                      value={newAddress.city}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">State</label>
                    <input
                      type="text"
                      name="state"
                      className="form-control"
                      placeholder="Enter state"
                      value={newAddress.state}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">ZIP Code *</label>
                    <input
                      type="text"
                      name="zip_code"
                      className="form-control"
                      placeholder="Enter ZIP code"
                      value={newAddress.zip_code}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="col-md-12">
                    <label className="form-label">Country *</label>
                    <select
                      name="country"
                      className="form-control"
                      value={newAddress.country}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Select Country</option>
                      <option value="USA">United States</option>
                      <option value="India">India</option>
                      <option value="Canada">Canada</option>
                      <option value="UK">United Kingdom</option>
                    </select>
                  </div>
                </div>
                <button type="submit" className="btn btn-primary mt-3 w-100">
                  <PlusCircle size={18} /> Add Address
                </button>
              </form>
            </div>

            <div className="card shadow p-4 mt-4">
              <h4 className="mb-3">Saved Addresses</h4>
              {shippingAddresses.length === 0 ? (
                <p className="text-muted">No addresses added yet.</p>
              ) : (
                <div className="list-group">
                  {shippingAddresses.map((address) => (
                    <div key={address.id} className="list-group-item d-flex justify-content-between align-items-center">
                      <div>
                        <MapPin size={18} className="me-2 text-primary" />
                        {`${address.address_line1}, ${address.city}, ${address.state}, ${address.zip_code}, ${address.country}`}
                      </div>
                      <button className="btn btn-sm btn-danger" onClick={() => handleDeleteAddress(address.id)}>
                        <Trash2 size={16} />
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShippingAddress;
